<template>
  <div id="private-cloud-main">
    <PrivateCloudMenu ref="PrivateCloudMenu" @projectChange="projectChange"></PrivateCloudMenu>
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import PrivateCloudMenu from './components/menu'
export default {
  name: 'private_cloud_main',
  components: {
    PrivateCloudMenu
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    projectChange () {
      this.reload()
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    },
    getCurrentSelectProject () {
      return this.$refs.PrivateCloudMenu.selectedProject
    }

  }
}
</script>

<style lang="less">
  #private-cloud-main {
    .ivu-table-wrapper {
      border: unset;
    }
    /*.ivu-table th {*/
      /*background-color: #fff;*/
    /*}*/
    .ivu-table:after {
      width: unset;
    }
    .ivu-table:before {
      height: unset;
    }
    .ivu-spin-fix {
      border: unset;
    }
  }
</style>
